import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL,
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  newHierarchy (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}newHierarchy/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetcHierarchies () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}fetcHierarchies`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  deleteHierarchy (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}deleteHierarchy/${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  }
}
